<template>
	<div>
		<h1>Mandanten zu Benutzer hinzufügen</h1>
		<select v-model="selected_user" @change="reloadTable">
			<option v-for="(user,idxusr) in users" :key="idxusr" :value="user.id">{{ user.name }}</option>
		</select>
		<button @click="openClientSelection" class="btnAdd"><i class="fas fa-plus"></i> Mandant hinzufügen</button>
		<table>
			<thead>
				<th>Mandant</th>
				<th></th>
			</thead>
			<tbody>
				<tr v-for="(rec,idx) in recs" :key="idx">
					<td>{{ rec.name }}</td>
					<td><i class="fas fa-trash-alt" @click="deleteConfirm(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Mandant '{{ delClientName }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalClientSelect" width="450" height="auto" :clickToClose="false" draggable=".delConf-title" @opened="$refs.fldsearch.focus()">
			<div class="delConf-title">Mandant auswählen</div>
			<div class="delConf-content clientselect">
				<input type="text" v-model="search_txt" placeholder="Suche..." @keyup.enter="search" class="left_space" ref="fldsearch"><br>
				<select v-model="selected_clients" size="6" multiple>
					<option v-for="(client,idxclient) in clients" :key="idxclient" :value="client.id">{{ client.name }}</option>
				</select>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="addOneRec">Auswahl hinzufügen</button>
				<button @click="addAllRec">Alle hinzufügen</button>
				<button @click="$modal.hide('modalClientSelect')">Abbrechen</button>
			</div>
		</modal>
		
		<vue-snotify></vue-snotify>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'

  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			id: 0,
			delClientName: '',
			search_txt: '',
			selected_user: '1',
			selected_clients: [],
			recs: [],
			clients: [],
			users: []
		}
	},
    methods: {
      reloadTable: function () {
		  this.apiCall([{method: 'userclient/list', param: {user_id: this.selected_user}, id: 5}], this.evalApiResponse)
      },
      search: function () {
		  this.apiCall([{method: 'client/list', param: {quicksearch: this.search_txt}, id: 35}], this.evalApiResponse)
      },
      openClientSelection: function () {
		  this.search_txt = ''
		  this.selected_clients = []
		  this.apiCall([{method: 'client/list', param: {}, id: 35}], this.evalApiResponse)
		  this.$modal.show('modalClientSelect')
      },
      addOneRec: function () {
		  if (this.selected_clients.length === 0) {
			  this.$snotify.error('Kein Mandant ausgewählt', 'ERROR', {timeout: 8000})
			  return
		  }
		  this.apiCall([{method: 'userclient/add', param: {user_id: this.selected_user, client_id: this.selected_clients}, id: 15},{method: 'userclient/list', param: {user_id: this.selected_user}, if: [{id: 15, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
//		  alert(JSON.stringify(this.selected_clients))
//		  this.$modal.hide('modalClientSelect')
      },
      addAllRec: function () {
		  var i, p = []
		  for(i=0; i<this.clients.length; i++) p.push(this.clients[i].id)
		  this.apiCall([{method: 'userclient/add', param: {user_id: this.selected_user, client_id: p}, id: 15},{method: 'userclient/list', param: {user_id: this.selected_user}, if: [{id: 15, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
//		  alert(JSON.stringify(p))
//		  this.$modal.hide('modalClientSelect')
      },
      deleteConfirm: function (id) {
		var vm = this
		vm.id = parseInt(id)
		
		vm.delClientName = 'unknown'
        vm.$_.forEach(vm.recs, function (value) {
			if (value.id == id) {
				vm.delClientName = value.name
				return false
			}
	    })
		
        vm.$modal.show('modalDel')
      },
      deleteRec: function () {
		this.$modal.hide('modalDel')
		this.apiCall([{method: 'userclient/remove', param: {user_id: this.selected_user, client_id: this.id}, id: 10},{method: 'userclient/list', param: {user_id: this.selected_user}, if: [{id: 10, path: 'result/success', eq: true}], id: 5}], this.evalApiResponse)
      },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 5: // 5 = Result from '.../list'
				vm.recs = value.result
                break
              case 10: // 10 = Result from '.../remove'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
				}
                break
              case 15: // 15 = Result from '.../add'
                if (value.hasOwnProperty('error')) {
					vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
                } else {
					vm.$modal.hide('modalClientSelect')
					vm.$snotify.success('Daten hinzugefügt', 'OK')
				}
                break
              case 25: // 25 = Result from '.../user/list'
				vm.users = value.result
                break
              case 35: // 35 = Result from '.../client/list'
				vm.clients = value.result
                break
            }
          }
        })
      }
    },
    mounted: function () {
		this.selected_user = 1 //TODO: user_id dynamisch aus vuex beziehen!!!
		this.apiCall([{method: 'core/user/list', param: {}, id: 25},{method: 'userclient/list', param: {user_id: this.selected_user}, id: 5}], this.evalApiResponse)
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

th:nth-child(1) {min-width: 300px}
td:nth-child(1) {min-width: 300px}
td:nth-child(2) {text-align: center}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

td > i {
	cursor: pointer;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.active {
	background: #080;
}

.badge.locked {
	background: #c00;
}

.badge.EFFECTIVE {
	background: #f38000;
}

.badge.NET_TAX_RATE {
	background: #bf22d7;
}

.btnAdd {
	margin-left: 20px;
}

/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.clientselect input, .clientselect select {
	width:100%;
	background: #fff;
	border: 1px solid #888;
	margin: 2px 0;
	padding: 3px;
}
</style>
